import { ChangePassword } from 'modules/users/components'
import { User, UserEmail, UserPassword } from 'framework/users'
import { useNotification, useUserSession } from 'hooks'
import type { FC } from 'react'
import { UserService } from 'modules/users/services'
import type { UserChangePasswordProps } from '.'

const UserChangePassword: FC<UserChangePasswordProps> = ({ userEmail, hasPasswordChanged }) => {
  const { notify } = useNotification()
  const { user } = useUserSession()

  async function onSubmit({ password }: { password: string }) {
    try {
      const userService = new UserService()
      if (user && user.id) {
        userService.setUser(user as unknown as User)
      }

      const email = !userEmail || (userEmail as unknown as string) === '' ? user.email : userEmail
      await userService.changePasswordFromForgot(password as unknown as UserPassword, email as unknown as UserEmail)

      notify({
        title: 'Sucesso',
        description: 'Sua senha foi alterada!',
        type: 'success',
      })

      if (typeof hasPasswordChanged === 'function') {
        hasPasswordChanged()
      }
    } catch (e) {
      notify({
        title: 'Atenção',
        description: 'Houve um erro ao atualizar sua senha. Tente novamente!',
        type: 'danger',
      })
    }
  }

  return <ChangePassword onSubmit={onSubmit} />
}

export default UserChangePassword
